module.exports = __webpack_public_path__ + "img/az.d3308e46.svg";